<template>
  <div class="forget-warpper">
    <div class="container-img">
      <div class="forget-img">
        <!--        <img src="../../assets/images/logo4.png" alt />-->
        <h1 class="websiteTitle" v-text="websiteTitle"></h1>
      </div>
      <div class="container">
        <infoForm
          ref="infoForm"
          title="忘记密码"
          fromType="forget"
          @on-submit="submitHandle"
          submit="提交"
          align="返回登录"
          @on-align="onAlign"
        >
          <el-form-item slot="forget" prop="captcha">
            <el-input v-model="captcha" placeholder="短信验证" type="username">
              <el-button
                slot="append"
                type="primary"
                class="sendBtn"
                @click="sendPhoneCode"
                :disabled="sendCodeBtnDisable"
                >{{ code_tip }}</el-button
              >
            </el-input>
          </el-form-item>
        </infoForm>
      </div>
    </div>
    <div class="record_num" v-text="icp_number"></div>
  </div>
</template>

<script>
import util from "@/utils";
import infoForm from "@/components/infoForm/index.vue";
import { forgetPassword, getCaptcha } from "@/api/index.js";
export default {
  name: "",
  components: {
    infoForm,
  },
  props: {},
  data() {
    return {
      code_time: 60,
      code_tip: "发送验证码",
      sendCodeBtnDisable: false,
      captcha: "",
      icp_number: util.icp_number,
      websiteTitle: util.copyrightName + util.WebsiteTitle,
    };
  },
  methods: {
    onAlign(type) {
      this.go("/login");
    },
    go(url) {
      this.$router.push({
        path: url,
      });
    },
    /*
     * 提示信息
     * */
    elementTips: function (type, message) {
      const $t = "";
      this.$message({
        showClose: true,
        message: message,
        type: type,
      });
    },
    /**
     * 提交
     */
    async submitHandle(userInfo) {
      var that = this;
      try {
        if (!this.captcha) {
          this.elementTips("error", "请输入验证码");
          return;
        }
        var params = {
          mobile: userInfo.username,
          password: userInfo.password,
          captcha: this.captcha,
        };
        let res = await forgetPassword(params);
        if (res.success) {
          this.elementTips("success", res.message);
          setTimeout(() => {
            that.go("/login");
          }, 1500);
        } else {
          this.elementTips("error", res.message);
        }
      } catch (error) {
        console.log(error);
      }
    },
    /*
     * 发送验证码
      注册绑定模式:0, 登录验证:1, 修改密码模式:2, 修改手机号:3；
     * */
    async sendPhoneCode() {
      try {
        let mobile = this.$refs.infoForm.loginForm.username;
        if (mobile === "") {
          this.elementTips("error", "手机号码不能为空");
          return;
        }
        const params = {
          smsMode: "2",
          mobile: mobile,
        };
        let res = await getCaptcha(params);
        if (res.success) {
          this.countDown();
          this.elementTips("success", res.message);
          this.sendCodeBtnDisable = true;
        } else {
          this.sendCodeBtnDisable = false; //错误的情况下 解除禁止
          this.elementTips("warning", res.message);
        }
      } catch (error) {
        console.log(error);
      }
    },
    /*
     * 倒计时
     * */
    countDown() {
      const timer = setInterval(() => {
        this.code_tip = this.code_time + "s";
        this.code_time--;
        if (this.code_time <= 0) {
          clearInterval(timer);
          this.sendCodeBtnDisable = false;
          this.code_tip = "获取验证码";
          this.code_time = 60;
        }
      }, 1000);
    },
  },
};
</script>

<style lang="scss" scoped>
.forget-warpper {
  background-image: url("../../assets/images/login-bg2.jpg");
  width: 100%;
  height: 100%;
  // position: relative;
  background-position: center;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-content: center;

  .container-img {
    position: relative;
    top: 15%;
    // left: 50%;
    // margin: -300px 0 0 -175px;
    width: 400px;
    overflow: hidden;
    border-radius: 15px;
    background-size: 100% 100%;
    .forget-img {
      text-align: center;
      margin: 20px 0;
      img {
        height: 70px;
      }
    }

    .websiteTitle {
      width: 100%;
      text-align: center;
      line-height: 50px;
      font-size: 30px;
      // color: #fc701a;
      font-family: Noto Sans S Chinese;
      font-weight: bold;
    }
  }

  .container {
    background: #ffffff;
    overflow: hidden;
    border-radius: 15px;
    background-size: 100% 100%;
    box-shadow: 0 0 30px #ccc;
    margin: 10px 20px 30px 20px;
  }
  .sendBtn {
    color: #fff;
    border-radius: 0;
  }
  .loginBtn {
    text-align: center;

    button {
      width: 100%;
      height: 36px;
      margin-bottom: 10px;
    }
  }
}
</style>
